import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../auth.service';

/**
 * Guard that protects the select-profile route.
 * Allows access if there is a pending profile selection — soit le flux courtier (temporaryToken
 * + profils compagnie), soit la sélection de profil générique (tout utilisateur multi-profil).
 */
@Injectable({
    providedIn: 'root'
})
export class BrokerPendingAuthGuard implements CanActivate {

    constructor(
        private _authService: AuthService,
        private _router: Router
    ) {}

    canActivate(): boolean | UrlTree {
        // Allow access if there is a pending broker auth OR a pending generic profile selection
        if (this._authService.hasPendingBrokerAuth || this._authService.hasPendingProfileSelection) {
            return true;
        }

        // No pending selection, redirect to sign-in
        return this._router.createUrlTree(['/sign-in']);
    }
}
